enum EOrderStep {
  ORDER_METHOD = 1,
  CALL_WOMAN = 2,
  ORDER_DETAIL = 3,
  SUMMARY_ORDER = 4,
}

enum EPost {
  RECOMMEND = 'recommend',
  MEMBER_BOARD = 'member_board',
}

enum EPostMode {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
  PREMIUM = 'PREMIUM',
  SALON = 'SALON',
}

enum ESalonMembershipType {
  NORMAL = 'NORMAL',
  PREMIUM = 'PREMIUM',
}

enum EFilterFemale {
  OPTIONS = 'options',
  SCHEDULES = 'schedules',
  DISCOUNT = 'discount',
  ACTIVITY_AREAS = 'activityAreas',
  KEYWORDS = 'keywords',
}

enum ESearchTab {
  PRODUCT_SHELF = 'product-shelf',
  JOB_SHELF = 'job-shelf',
  SCHEDULES = 'work-today',
  LIST_EMPLOYEE = 'list-employee',
  PICKUPS = 'pickups',
  RANKING = 'ranking',
  HOT_VIDEO = 'hot-video',
}

enum ESettingNoti {
  GROUP_CHAT = 'groupChat',
  STAFF_MESSAGE = 'managementChat',
  GIRL_MESSAGE = 'privateChat',
  CONFLUENCE = 'joinedChat',
  GAME_SELECTION = 'gameSelection',
  PROFILE_REQUEST = 'profileRequest',
  SMS_DELIVERY = 'smsDelivery',
}

enum EActionChat {
  SELECT_GAME = 1,
  LIST_GAME = 2,
  ORDER_METHOD = 3,
  ADD_GIRL = 4,
  RELEASE_GIRL = 5,
}

enum EGameType {
  COMMON = 'COMMON',
  COMMON_SPECIAL = 'COMMON_SPECIAL',
  SINGLE_SPECIAL = 'SINGLE_SPECIAL',
  GROUP_SPECIAL = 'GROUP_SPECIAL',
  GROUP_KING = 'GROUP_KING',
}

enum EUserProvider {
  MALE_APPLICATION = 'MALE_APPLICATION',
  FEMALE_APPLICATION = 'FEMALE_APPLICATION',
  MANAGEMENT_APPLICATION = 'MANAGEMENT_APPLICATION',
}

enum ESystemMobile {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  OTHER = 'OTHER',
}

enum ENotificationType {
  PRIVATE = 'PRIVATE',
  MANAGEMENT = 'MANAGEMENT',
  PROJECT = 'PROJECT',
  SHIFT_MANAGEMENT = 'SHIFT_MANAGEMENT',
  NEW_POST = 'NEW_POST',
  NEW_IMAGE_REQUEST = 'NEW_IMAGE_REQUEST',
}

enum EChannelType {
  PRIVATE = 'PRIVATE',
  GROUP = 'GROUP',
  SALON = 'SALON',
  MALE_MANAGEMENT = 'MALE_MANAGEMENT',
  MALE_SYSTEM_MANAGEMENT = 'MALE_SYSTEM_MANAGEMENT',
  FEMALE_MANAGEMENT = 'FEMALE_MANAGEMENT',
  PROJECT = 'PROJECT',
  SHIFT_MANAGEMENT = 'SHIFT_MANAGEMENT',
}

enum EPaymentMethod {
  CASH = 'CASH',
  CARD = 'CARD',
  POINT = 'POINT',
  VISA = 'VISA',
  BANK = 'BANK',
  POSTPAY = 'POSTPAY',
}

enum EDeferralRequestType {
  POSTPAY = 'POSTPAY',
  BANK = 'BANK',
}

enum ECardMethod {
  VISA = 'VISA',
  OTHERS = 'OTHERS',
}

enum EAppInfo {
  ABOUT_APP = 'about-app',
  COMMUNICATION_GUIDE = 'communication-guide',
  TERMS_OF_SERVICE = 'terms-of-service',
  PRIVACY_POLICY = 'privacy-policy',
  LEGAL_COMPLIANCE_POLICY = 'legal-compliance-policy',
  SPECIAL_COMMERCIAL_LAW = 'special-commercial-law',
}

enum EProfileInfo {
  AGE = 'age',
  INCOME = 'income',
}

enum EStatusProfile {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
}

enum EProjectType {
  BASIC = 'BASIC',
  SALON = 'SALON',
}

enum EProjectStatus {
  SUCCESS = 'SUCCESS',
  PENDING = 'PENDING',
  INPROGRESS = 'INPROGRESS',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
}

enum EStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

enum EStar {
  EMPTY = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
}

enum EGiftPaymentStep {
  GIFTS_PREDICT = 1,
  CHOOSE_METHOD = 2,
  CHOOSE_CARD = 3,
}

enum EPaymentType {
  BANK = 'BANK',
  CARD = 'CARD',
  CASH = 'CASH',
  PREPAID = 'PREPAID',
  POINT = 'POINT',
}

enum EPointRequestStatus {
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

enum EPointHistoryType {
  ADDED = 'ADDED',
  SUBTRACTED = 'SUBTRACTED',
}

enum EPointPaymentStep {
  PROCESSING_DETAIL = 1,
  PAYMENT = 2,
}

enum ETransferStep {
  APPLY = 1,
  TRANSFER = 2,
  TECO_FEE = 3,
}

enum EUserPlatform {
  APP = 'APP',
  WEB = 'WEB',
}

enum EPaymentFor {
  PROJECT = 'PROJECT',
  REQUEST = 'REQUEST',
  GIFT = 'GIFT',
  POINT = 'POINT',
}

enum ERankingPeriod {
  YESTERDAY = 'YESTERDAY',
  RECENT_7_DAYS = 'RECENT_7_DAYS',
  RECENT_30_DAYS = 'RECENT_30_DAYS',
  LAST_WEEK = 'LAST_WEEK',
  LAST_MONTH = 'LAST_MONTH',
}

enum ERankingProjectType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
  NEWCOMER = 'NEWCOMER',
}

enum ApproveRejectMode {
  STEP1_PROJECT_INFO = 'STEP1_PROJECT_INFO',
  STEP2_AGREEMENT = 'STEP2_AGREEMENT',
}

enum EArea {
  TOKYO = '東京',
  OSAKA = '大阪',
  AICHI = '愛知',
  FUKUOKA = '福岡',
  KANAGAWA = '神奈川',
}

enum ESearchShelfType {
  PRODUCT = 'product',
  JOB = 'job',
}

export {
  EOrderStep,
  EPost,
  EPostMode,
  ESalonMembershipType,
  EFilterFemale,
  EActionChat,
  ESearchTab,
  EGameType,
  EUserProvider,
  ESettingNoti,
  ESystemMobile,
  ENotificationType,
  EPaymentMethod,
  EDeferralRequestType,
  EChannelType,
  EAppInfo,
  EProfileInfo,
  EStatusProfile,
  EProjectStatus,
  EProjectType,
  EStar,
  EGiftPaymentStep,
  EPaymentType,
  EPointRequestStatus,
  EPointHistoryType,
  EPointPaymentStep,
  ETransferStep,
  ECardMethod,
  EUserPlatform,
  EPaymentFor,
  ERankingPeriod,
  ERankingProjectType,
  EStatus,
  ApproveRejectMode,
  EArea,
  ESearchShelfType,
};
